"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlmeSessionDataUtils = void 0;
var AlmeSessionDataUtils = /** @class */ (function () {
    function AlmeSessionDataUtils() {
    }
    /**
     * Generates a new alme session data object with randomly generated sessionId and userId.
     */
    AlmeSessionDataUtils.CreateAlmeSessionData = function () {
        return {
            sessionId: this.uuidv4(),
            userId: this.uuidv4(),
            lastActivityTime: null,
        };
    };
    /**
     * Creates a random uuid v4.
     */
    AlmeSessionDataUtils.uuidv4 = function () {
        var cryptoRef;
        try {
            cryptoRef = crypto;
        }
        catch (e) {
            // IE 11 required experimental msCrypto.
            // https://developer.mozilla.org/en-US/docs/Web/API/Window/crypto#Browser_compatibility
            cryptoRef = window.msCrypto;
        }
        // javascript crazyness.  Number array plus number is actually converted to a string.  This results in a string like ("10000000-1000-4000-8000-100000000000")
        // all 0, 1, 8 characters are replaced with a new random number.
        return ([1e7] +
            -1e3 +
            -4e3 +
            -8e3 +
            -1e11).replace(/[018]/g, function (c) {
            return (((c ^ cryptoRef.getRandomValues(new Uint8Array(1))[0]) & 15) >> c / 4).toString(16);
        });
    };
    return AlmeSessionDataUtils;
}());
exports.AlmeSessionDataUtils = AlmeSessionDataUtils;
//# sourceMappingURL=AlmeSessionDataUtils.js.map